module.exports = __webpack_public_path__ + "static/media/landing-banner.5dcbd9f4.png";